import { ArticleTemplate } from '../AddArticle';
import ArticleTemplateComponent from './ArticleTemplateComponent';

const ArticleTemplateTwo = () => <ArticleTemplateComponent
  template={ArticleTemplate.TEMPLATE_TWO}
/>

export default ArticleTemplateTwo;
